export default function getCitiesFromPackages(packages) {
    let cities = [];
    const slugs = [];
    for(var i = 0, l = (packages || []).length, item; i < l; ++i) {
        item = packages[i];
        for(var x = 0, ll = item.data.length, citiesToMerge, pkg; x < ll; ++x) {
            pkg = item.data[x];
            if(pkg.venue == null || pkg.venue.cities == null)
                continue;

            citiesToMerge = [];
            for(var y = 0, lll = pkg.venue.cities.length; y < lll; ++y) {
                if(slugs.indexOf(pkg.venue.cities[y].slug) > -1)
                    continue;
                slugs.push(pkg.venue.cities[y].slug);
                citiesToMerge.push(pkg.venue.cities[y]);
            }

            cities = cities.concat(citiesToMerge);
        }
    }

    cities.sort(function citySorter(a, b) {
        return a.title.localeCompare(b.title);
    });

    return cities;
}